// extracted by css-extract-rspack-plugin
export default {"activeItem":"XAM6i"};